/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

/**
 * FEATURE FLAGS
 */

export type FeatureFlagSet = Record<FeatureFlags, boolean>;

export enum FeatureFlags {
  devToolsEnabled = 'devToolsEnabled',
  featureAgentFaq = 'featureAgentFaq',
  featureSuperChart = 'featureSuperChart',
  functionImportStatus = 'functionImportStatus',
  functionInsightsAnalytics = 'functionInsightsAnalytics',
  functionTrusstedAgent = 'functionTrusstedAgent',
  ingestImportJobLanguageSelector = 'ingestImportJobLanguageSelector',
  teamsAndUsersFilters = 'teamsAndUsersFilters',
  testAgent = 'testAgent',
}

export const featureFlagDefaults = {
  [FeatureFlags.devToolsEnabled]: false,
  [FeatureFlags.featureAgentFaq]: false,
  [FeatureFlags.featureSuperChart]: false,
  [FeatureFlags.functionImportStatus]: false,
  [FeatureFlags.functionInsightsAnalytics]: false,
  [FeatureFlags.functionTrusstedAgent]: false,
  [FeatureFlags.ingestImportJobLanguageSelector]: false,
  [FeatureFlags.teamsAndUsersFilters]: false,
  [FeatureFlags.testAgent]: false,
};
